import reqwest from 'reqwest';
import { apiUrl } from './config';

export default {
  /**
   * 获取手机验证码
   */
  getSmsCode(data) {
    return reqwest({
      url: `${apiUrl}/official-api/api/sys/getPhoneValidateCode/${data.mobileNumber}`,
    });
  },
  /**
   * 获取vip订单信息
   */
  getVipOrderInfo() {
    return reqwest({
      url: `${apiUrl}/official-api/api/pay/getPrePayOrder`,
    });
  },
  /**
   * 检查订单状态
   */
  checkVipOrderStatus(data) {
    return reqwest({
      url: `${apiUrl}/official-api/api/pay/getPayOrderStatus`,
      data,
    });
  },
  /**
   * 获取用户信息
   */
  getVipTransferUserInfo(data) {
    return reqwest({
      url: `${apiUrl}/official-api/api/user/worker/${data.number}`,
    });
  },
  /**
   * 获取渠道价格
   */
  getVipPrice() {
    return reqwest({
      url: `${apiUrl}/official-api/api/pay/getOfficialVipOrderInfo`,
    });
  },
  /**
   * 获取帮助说明详情
   */
  getHelpTextDetail(data, opt) {
    return reqwest({
      url: `${apiUrl}/business-api/api/sys/help/getHelpNotesSettingDetail`,
      data,
      ...opt,
    });
  },
  saveHelpNoteTimesWhenClick(data, opt) {
    return reqwest({
      url: `${apiUrl}/business-api/api/sys/help/saveHelpNoteTimesWhenClick`,
      data,
      ...opt,
    });
  },
  uploadFile(data, opt) {
    return reqwest({
      url: `${apiUrl}/business-api/api/file/upload`,
      method: 'post',
      processData: false,
      data,
      ...opt,
    });
  },
  uploadFile2c(data, opt) {
    return reqwest({
      url: `${apiUrl}/customer-api/api/sys/uploadFile`,
      method: 'post',
      processData: false,
      data,
      ...opt,
    });
  },
  agreeAudit2c(data, opt) {
    return reqwest({
      url: `${apiUrl}/customer-api/api/smartPayroll/group/agreeAudit`,
      method: 'post',
      data: JSON.stringify(data),
      contentType: 'application/json',
      ...opt,
    });
  },
  agreeAudit(data, opt) {
    return reqwest({
      url: `${apiUrl}/business-api/api/smartPayroll/group/agreeAudit`,
      method: 'post',
      data: JSON.stringify(data),
      contentType: 'application/json',
      ...opt,
    });
  },
  getHotCategoryList(data, opt) {
    return reqwest({
      url: `${apiUrl}/artisan-wxlite-api/api/sys/dict/get-hot-category-list`,
      contentType: 'application/json',
      ...opt,
    });
  },
  getWorkerHistoryCategoryDictList(datqa, opt) {
    return reqwest({
      url: `${apiUrl}/artisan-wxlite-api/api/worker/category/v1/get-worker-history-category-dict-list`,
      contentType: 'application/json',
      ...opt,
    });
  },
};
